module.exports = __webpack_public_path__ + "media/images/badge/partita-fortunata-4de306092e951b79bd96e891dca27d4f.png";